import { createFileRoute } from '@tanstack/react-router'
import { RejectReasonsSettingsPage } from '@/features/settings/components/reject-reasons-settings-page'

export const Route = createFileRoute(
  '/_app/_auth/dashboard/_layout/settings/reject-reasons',
)({
  component: RejectReasonsSettingsPage,
  beforeLoad: async () => {
    return {
      title: 'Reject reasons',
      headerTitleKey: 'header.rejectReasons.title',
      headerDescriptionKey: 'header.rejectReasons.description',
    }
  },
})
